module.exports = __webpack_public_path__ + "img/US.1425e567.svg";